//Import required modules
import React from 'react';
import PropTypes from 'prop-types'

//Import BootStrap Containers
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

//Import Components
import ColorPalette from '../Colors/ColorPalette'
import UserPalette from '../User/UserPalette'
import Simulate from '../Simulation/Simulate'
import ColorClip from './ColorClip'
import Card from 'react-bootstrap/Card'


//Navbar Component
const Content = (props, {store}) =>
{
    let theme = store.getState().theme;
    let contStyle = {
        // height: '85vh',
        // justifyContent: 'center',
    }
    return (
    <>
        <ColorClip />
        <Container fluid className={`${theme}`} style={contStyle}>
            <Row>

                <Col sm={6}>
                    <ColorPalette />
                </Col>

                <Col sm={6}>
                    <Row>
                        <Col sm={12}>
                            <Card className={`${theme}`}>
                                <UserPalette />
                                <Simulate />
                            </Card>    
                        </Col>
                    </Row>
                </Col>

            </Row>
        </Container>
    </>
    )
}

Content.contextTypes = {
    store: PropTypes.object
}

export default Content